import { Menu, MenuOpen } from "@mui/icons-material";
import { alpha, IconButton, Paper, Toolbar, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { appMenuItems } from "../utils/routes";
import { UserMenu } from "./UserMenu";
//
const useStyles = makeStyles()((theme) => ({
	paper: {
		backgroundColor: "white",
		boxShadow: "rgba(17, 12, 46, 0.05) 0px 4px 10px 0px",
		position: "sticky",
		top: 0,
		right: 0,
		zIndex: 1,
		borderRadius: 0,
	},
	title: {
		flexGrow: 1,
		display: "none",
		textTransform: "capitalize",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: alpha(theme.palette.primary.light, 0.15),
		"&:focus-within": {
			backgroundColor: alpha(theme.palette.primary.light, 0.05),
		},
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(1),
			width: "auto",
		},
	},
	searchIcon: {
		padding: theme.spacing(0, 2),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	inputRoot: {
		color: "inherit",
	},
	inputInput: {
		padding: theme.spacing(1.25),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			width: "24ch",
			"&:focus": {
				width: "40ch",
			},
		},
	},
}));

export const Navbar = ({ user, open, toggleDrawer }) => {
	const { classes } = useStyles();
	const location = useLocation();
	const routes = appMenuItems;

	const getBrandText = (path) => {
		if (path === "/" || path === "") {return "Dashboard";}

		// Try to match a top-level route
		const route = routes.find((r) => r.link === path);

		if (route) {return route.name;}

		// Try to match a nested route (flattened from parents with items)
		const nestedItems = routes
			.filter((r) => Array.isArray(r.items))
			.flatMap((r) => r.items);

		const nestedMatch = nestedItems.find((item) => item.link === path);
		if (nestedMatch) {return nestedMatch.name;}

		// Fallback
		return "Dashboard";
	};
	const title = getBrandText(location.pathname.split("/").slice(0).join("/"));
	return (
		<Paper className={classes.paper}>
			<Toolbar>
				<IconButton
					color="inherit"
					aria-label="open drawer"
					onClick={toggleDrawer}
					edge="start"
					sx={[
						{
							display: { xs: "none", sm: "block" },
							marginRight: 5,
						},
						//   open && { display: 'none' },
					]}
				>
					{open ? <MenuOpen /> : <Menu />}
				</IconButton>
				<IconButton
					color="inherit"
					aria-label="open drawer"
					onClick={toggleDrawer}
					edge="start"
					sx={[
						{
							display: { xs: "block", sm: "none" },
							marginRight: 5,
						},
						//   open && { display: 'none' },
					]}
				>
					{open ? <MenuOpen /> : <Menu />}
				</IconButton>
				<Typography className={classes.title} variant="h5" noWrap>
					{title}
				</Typography>

				<UserMenu user={user} />
			</Toolbar>
		</Paper>
	);
};
